import { EXAMPLE_TYPES } from '../../../../types';

export const getDefaultLanguage = (renderFor: EXAMPLE_TYPES) => {
  if (renderFor === EXAMPLE_TYPES.REQUEST) {
    return 'bash';
  }
  if (renderFor === EXAMPLE_TYPES.JS_FUNCTION) {
    return 'javascript';
  }
  return 'json'; // type is an object
};
